import ViewerPage from './viewer';
import { ZonesManagement as NewZonesManagement } from '@/components/ZonesManagementRevamped';
import { useFeatureFlag } from '@/hooks';
import { DrawerLayout } from '@/layouts';

export const AssetLabellingDefaultPage = () => {
  const isNewZonesManagement = useFeatureFlag('beta-user');

  return (
    <DrawerLayout variant="labelling">
      {isNewZonesManagement ? <NewZonesManagement /> : <ViewerPage />}
    </DrawerLayout>
  );
};
